const sevicesData = [
  {
    id: "1",
    heading: "Business Process Re-Engineering",
    icon: "engineering",
    desc: "We re-design the way your work should be done to better support your business goals ",
  },
  {
    id: "2",
    heading: "Cost Management for Operations and Projects",
    icon: "calculate",
    desc: " We identify and introduce practices that would reduce your business expenses to maximize your organizations profit. ",
  },
  {
    id: "3",
    heading: "Project and Business Funding",
    icon: "euro",
    desc: " Financial Management and project financing Services to assure the liquidity position of your business.",
  },
  {
    id: "4",
    heading: "Asset Leasing and Logistics",
    icon: "article",
    desc: " We provide lease or rental opportunities for businesses that require same by linking them with asset vendors and funders. We also lease out assets, motorbikes and vehicles for logistics and delivery services.",
  },
  {
    id: "5",
    heading: "Financial Sytems and Controls",
    icon: "calculate",
    desc: " We provide business process and structures that would deliver increased your business efficiency and productivity ",
  },
  {
    id: "6",
    icon: "auto_fix_high",
    heading: "Tax Management",
    desc: "We proffer advisory services in tax planning and finance management to ensure compliance to the legal tax requirement of the Government",
  },
];

export default sevicesData;
